import { render, staticRenderFns } from "./zoom.vue?vue&type=template&id=1157db86&"
import script from "./zoom.vue?vue&type=script&lang=js&"
export * from "./zoom.vue?vue&type=script&lang=js&"
import style0 from "./zoom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1157db86', component.options)
    } else {
      api.reload('1157db86', component.options)
    }
    module.hot.accept("./zoom.vue?vue&type=template&id=1157db86&", function () {
      api.rerender('1157db86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/layout/zoom.vue"
export default component.exports